<div class="value-text align-center">Comprehensive exams. Daily support.</div>
<div class="second-heading">Preventive care that works.</div>
<div class="corporate-link">
	<a href="https://ehe.health/" target="_blank" class="link">Visit ehe.health</a>
</div>
